module.exports = __webpack_public_path__ + "img/7.64837d21.png";